<!-- 解析卡 -->
<template>
  <div>
    <div class="header">
      <img @click="pushHome" alt src="@/assets/img/h5/left.png" />
      <div class="tab">
        <div :class="active_type == 0? 'actives': ''" @click="setType(0)" class="tab_li">
          <div>全部试题</div>
          <div class="line" v-if="active_type == 0"></div>
        </div>
        <div :class="active_type == 1? 'actives': ''" @click="setType(1)" class="tab_li">
          <div>只看错题</div>
          <div class="line" v-if="active_type == 1"></div>
        </div>
        <!-- <div :class="active_type == 2? 'actives': ''" @click="setType(2)" class="tab_li">
          <div>只看对题</div>
          <div class="line" v-if="active_type == 2"></div>
        </div>-->
      </div>
      <img
        @click="collect"
        src="@/assets/img/h5/newQuestioncollect1@2x.png"
        v-if="!data_li.isCollect"
      />
      <img
        @click="collect"
        src="@/assets/img/h5/newQuestioncollect2@2x.png"
        v-if="data_li.isCollect"
      />
    </div>
    <div class="my_Body">
      <div class="question_box">
        <div class="question_header">
          <div class="header_desc" v-if="question_type == 1">单选题</div>
          <div class="header_desc" v-if="question_type == 2">多选题</div>
          <div class="header_desc" v-if="question_type == 3">判断题</div>
          <!-- <div class="header_desc" v-if="question_type == 4">简答题</div> -->
          <div @click="istrue = true" class="header_count">
            {{page_index}}/{{count}}
            <img src="@/assets/img/h5/newQuestiondown@2x.png" />
          </div>
        </div>
        <div class="question_body" v-if="data_li">
          <RadioParsing :bankdata="data_li" :typetext="'单选题'" v-if="question_type == 1"></RadioParsing>
          <CheckParsing :bankdata="data_li" :typetext="'多选题'" v-if="question_type == 2"></CheckParsing>
          <RadioParsing :bankdata="data_li" :typetext="'判断题'" v-if="question_type == 3"></RadioParsing>
          <!-- <TextParsing :bankdata="data_li" :typetext="'简答题'" v-if="question_type == 4"></TextParsing> -->
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="page">
        <el-pagination
          :current-page.sync="page_index"
          :disabled="loading"
          :page-size="1"
          :total="count"
          @current-change="handleSizeChange"
          layout="prev,next"
          next-text="下一页"
          prev-text="上一页"
        ></el-pagination>
        <!-- <div @click="submit_sub" class="submit" v-if="dataAll.length == page_index">结束</div> -->
      </div>
    </div>
    <ParsingSheet
      :activeindex="page_index"
      :bankdata="   active_type ==0? dataAll : warningAndTruedataAll"
      :isanwers="true"
      :istrues="istrue"
      :numcount="0"
      v-if="dataAll && dataAll.length > 0"
      v-on:getstatus="getstatus"
      v-on:getvalue="getvalue"
    ></ParsingSheet>
  </div>
</template>

<script>
import ParsingSheet from '@/components/h5/questionBank/ParsingSheet.vue'
import CheckParsing from '@/components/h5/questionBank/CheckParsing.vue'
import RadioParsing from '@/components/h5/questionBank/RadioParsing.vue'
// import TextParsing from '@/components/h5/questionBank/TextParsing.vue'
import * as QUESTION_API from '@/api/ExaminationAPI'
export default {
  components: {
    ParsingSheet,
    CheckParsing,
    RadioParsing,
    // TextParsing
  },
  data () {
    return {
      copyData: [],
      title: '',
      baseUrl: sessionStorage.getItem('base_url') || '',
      loading: false,
      count: 0,
      page_index: 1,
      question_type: 1,
      token: '',
      data_li: '',
      dataAll: '',
      istrue: false,
      is_keep: false,
      active_type: sessionStorage.getItem('active_type') || 0,
      isFeed: false,
      isDisbeld: true,
      ExaminationInfo: '',  //试卷信息
      examinationItemList: [],
      numcount: '',
      warningAndTruedataAll: [],
    };
  },
  computed: {},
  watch: {},
  created () {
    this.active_type = 0
    console.log('此解析页面')
    //从课程详细页面开始解析跳转此页面
    if (this.$route.params.data) {
      this.ExaminationInfo = this.$route.params
    } else {
      this.ExaminationInfo = JSON.parse(sessionStorage.getItem('parsingPage'))
    }
    if (this.$route.params.istrue) {
      this.istrue = this.$route.params
    }
    this.initData()
  },
  mounted () {

  },
  destroyed () {
  }, //生命周期 - 销毁完成
  //方法集合
  methods: {

    // 答题卡数据
    initData () {
      let params = {
        examinationId: this.ExaminationInfo.examinationId,
        type: 3,
        withTestLog: true,//查询用户答题数据需要字段
        withCollect: true
      }
      //查询当前用户答题记录数据
      QUESTION_API.examinationItemList(params).then(res => {
        console.log('查询当前用户答题记录数据', res)
        if (res && Number(res.code) === 0) {
          this.examinationItemList = res.data;
          this.numcount = this.examinationItemList.length
          this.count = res.data.length
          let data = []
          for (let i = 0; i < this.examinationItemList.length; i++) {
            data[i] = this.examinationItemList[i]
            data[i].order = (i + 1)

          }
          this.dataAll = data
          this.copyData = this.dataAll
          this.data_li = this.dataAll[this.page_index - 1]
          this.data_li.order = this.page_index
          this.question_type = this.data_li.questionType

        } else {
          this.dataAll = []
          this.$message.warning(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 点击提交试题错误反馈
    setFeed: function () {
      this.FeedFn()
    },
    setType (val) {
      console.log(val)
      this.active_type = val
      this.loading = true
      if (this.active_type == 0) {
        this.dataAll = this.copyData
        this.page_index = 1
        this.data_li = this.dataAll[this.page_index - 1]
        this.question_type = this.data_li.questionType
        this.count = this.dataAll.length
      } else {
        let setArr = []
        for (let s = 0; s < this.copyData.length; s++) {
          if (this.active_type == 1 && !this.copyData[s].isCorrect) {
            console.log('错')
            setArr.push(JSON.parse(JSON.stringify(this.copyData[s])))
          }
          if (this.active_type == 2 && this.copyData[s].isCorrect) {
            console.log('错')
            setArr.push(JSON.parse(JSON.stringify(this.copyData[s])))
          }
        }
        for (let z = 0; z < setArr.length; z++) {
          setArr[z].order_size = z + 1
        }
        this.warningAndTruedataAll = setArr
        this.page_index = 1
        this.data_li = this.warningAndTruedataAll[this.page_index - 1]
        this.question_type = this.data_li.questionType
        this.count = this.warningAndTruedataAll.length
      }

      let that = this
      setTimeout(function () {
        that.loading = false
      }, 1000)
    },
    handleSizeChange (val) {
      this.page_index = val
      this.data_li = this.dataAll[this.page_index - 1]
      this.data_li.order = val
      this.question_type = this.data_li.questionType
    },
    pushHome () {
      this.$router.back()
    },

    //试题收藏
    collect () {
      if (this.data_li.isCollect) {
        this.editCollect(1)
      } else {
        this.editCollect(0)
      }
    },
    //试题收藏
    editCollect (isDelete) {
      let myAnswer = this.data_li.select.indexOf('[') > -1 ? '' : this.data_li.select
      let data = {
        examinationItemId: this.data_li.examinationItemId,
        examinationId: this.data_li.examinationId,
        questionType: this.data_li.questionType,
        myAnswer: myAnswer,
        topTypeId: this.ExaminationInfo.topTypeId,
        courseId: this.ExaminationInfo.courseId,
        isDelete: isDelete
      }
      QUESTION_API.editExaminationItemCollect(data).then(res => {
        if (res && Number(res.code) === 0) {
          this.$message.success(res.msg, 200)
          this.data_li.isCollect = !this.data_li.isCollect
        } else {
          this.$message.warning(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getstatus: function (val) {
      this.istrue = val
    },
    // 点击跳转题目
    getvalue: function (val) {
      this.page_index = val.order
      this.data_li = this.dataAll[this.page_index - 1]
      console.log('this.data_li', this.data_li)
      this.question_type = this.data_li.questionType
    },
  },
}
</script>
<style scoped>
.header {
  width: 100%;
  display: flex;
  align-items: center;
  font-weight: bold;
  padding: 0.84375rem;
  justify-content: space-between;
  border-bottom: 1px solid #eeeeee;
}
.header .tab {
  display: flex;
  align-items: center;
}
.tab_li {
  margin: 0 0.5rem;
  font-weight: 0;
  position: relative;
}
.actives {
  color: #ff2740;
}
.line {
  width: 100%;
  height: 2px;
  background-color: #ff2740;
  position: absolute;
  left: 0;
  bottom: -0.90625rem;
}
.header img {
  width: 1.2rem;
}
.footer {
  position: fixed;
  height: 3rem;
  display: flex;
  padding: 0 0 0 4%;
  width: 96%;
  align-items: center;
  justify-content: flex-end;
  left: 0;
  bottom: 0;
}
.Feed {
  position: relative;
}

.Feedback {
  position: absolute;
  left: 0.35rem;
  width: 6.25rem;
  display: flex;
  justify-content: center;
  padding-top: 0.35rem;
  color: #ff4b60;
  height: 2.125rem;
  top: -2.7rem;
  background-image: url(~@/assets/img//h5/feedblack.png);
  background-size: cover;
}
.page {
  position: relative;
}

.timeOut {
  display: inline-flex;
  color: #ff2740;
  align-items: center;
}

.timeOut img {
  height: 1.125rem;
  margin-right: 0.25rem;
}

.submit {
  position: absolute;
  font-size: 1rem;
  letter-spacing: 0.5rem;
  color: #ff2740;
  background-color: #fff;
  padding: 0.25rem 0.5625rem;
  cursor: pointer;
  right: 0;
  top: 0;
}

.footer button {
  color: #ff2740;
}
.footer button span {
  font-size: 1rem;
}

.footer button:disabled {
  color: #bbb;
}
.my_Body {
  width: 100%;
  height: 85vh;
  overflow-y: scroll;
  padding: 0.84375rem;
}

.question_box {
  width: 100%;
}

.question_header {
  margin-top: 1rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.question_body {
  margin-top: 1rem;
}
.question_header img {
  width: 0.65rem;
  margin-left: 0.2rem;
}

.header_count {
  display: inline-flex;
  align-items: center;
}

/*隐藏滚动条*/
::-webkit-scrollbar {
  width: 0;
  height: 0;
  color: transparent;
}
</style>